import {IconNames, usePlatform, useStorageItemValue} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useState} from "react";
import {useLocalization} from "../i18n";
import {logger} from "./logger";
import {Account, RecipientSelection} from "./model";
import {RecipientSelectionView} from "./RecipientSelectionView";
import {SuccessView} from "./SuccessView";
import style from "./styles.module.css";

const log = logger.sub("DoorBellFlow");

export type DoorbellAccount = Account & { doorBellSerialNr: string };

interface DeliveryFlowProps {
	doorbells: Array<DoorbellAccount>;
	onExit: () => void;
}

export function DoorBellFlow({onExit, doorbells}: DeliveryFlowProps) {
	const {doorbell} = usePlatform();
	const {t} = useLocalization();
	const recipientSelection = useStorageItemValue<RecipientSelection>("recipientSelection");
	const poBoxUrl = useStorageItemValue<string>("poBoxUrl");

	const [rang, setRang] = useState(false);

	const handleRecipientSelectionBack = useCallback(() => {
		onExit();
	}, [onExit]);

	const sendRingRequestForRecipient = (recipient: Account) => {
		log.info("Someone activated door be for recipient", recipient);
		const {doorBellSerialNr} = doorbells.find(a => a.id == recipient.id) ?? {};
		if (doorBellSerialNr) {
			doorbell.ring(doorBellSerialNr);
			setRang(true);
		}
	};

	if (!rang) {
		return (
			<RecipientSelectionView
				onBack={handleRecipientSelectionBack}
				onSelect={sendRingRequestForRecipient}
				recipientSelection={recipientSelection || RecipientSelection.Search}
				accounts={doorbells ?? []}
				poBoxUrl={poBoxUrl}
                title={t("DoorBellSelectRecipientTitle")}
                description={t("DoorBellSelectRecipientDescription")}
			/>
		);
	}

	return (
		<SuccessView
			title={t("DoorBellSuccessTitle")}
			message={t("DoorBellSuccessMessage")}
			icon={IconNames.notifications}
            iconClass={style.shake}
			onClose={onExit}
		/>
	);
}
